import { render, staticRenderFns } from "./VrRefundForm.vue?vue&type=template&id=7dc87be2&scoped=true&"
import script from "./VrRefundForm.vue?vue&type=script&lang=js&"
export * from "./VrRefundForm.vue?vue&type=script&lang=js&"
import style0 from "./VrRefundForm.vue?vue&type=style&index=0&id=7dc87be2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc87be2",
  null
  
)

export default component.exports